
class URLs {
    constructor () {
        this.urls = {
            'create': this._create,
            'forgot_password': null,
            'gallery': this._gallery,
            'gallery/category': (data) => { return `/gallery/category/${data.category}/`; },
            'ajax_gallery_suggestions': (data) => { return `/ajax/gallery/suggestions/${data.search}/`; },
            'ajax_gallery_category': (data) => { return `/ajax/gallery/${data.category}/`; },
            'ajax_gallery_category_featured': (data) => { return `/ajax/gallery/${data.category}/featured/`; },
            'ajax_event_settings': (data) => { return `/ajax/event/${data.event_id}/view/settings/`; },
            'ajax_event_guestlist': (data) => { return `/ajax/event/${data.event_id}/guestlist/?gid=${data.gid}`; },
            'ajax_event_avatars': (data) => { return `/ajax/event/${data.event_id}/guestlist/avatars/?gid=${data.gid}`; },
            'ajax_edit_guest_tags': (data) => { return `/ajax/event/${data.event_id}/posts/${data.post_id}/tags/?gid=${data.gid}`; },
            'ajax_render_event_image': (data) => { return `/ajax/event/${data.event_id}/renderimage/`; },
            'ajax_event_posts': (data) => { return `/ajax/event/${data.event_id}/posts/?cursor=${data.cursor || ''}&gid=${data.gid}`; },
            'ajax_event_photos': (data) => { return `/ajax/event/${data.event_id}/posts/photos/?per_page=${data.per_page || 10}&cursor=${data.cursor || ''}&gid=${data.gid}`; },
            'ajax_event_guestlist_search': (data) => { return `/ajax/event/${data.event_id}/guestlist/search/?q=${data.search_term}&gid=${data.gid}`; },
            'login': '/login/',
            'login_modal': '/login_modal/',
            'recaptcha': '/modal/recaptcha/',
            'sms_captcha': '/modal/sms_captcha/',
            'ad_captcha': '/modal/ad_captcha/',
            'modal_dialog': '/modal/dialog',
            'modal_warning': '/modal/warning',
            'modal_loading': '/modal/loading',
            'modal_ajax_error': '/modal/ajax_error/',
            'import_contacts': '/profile/contacts/import/',
            'ajax_user_status': '/ajax/settings/account/status/',
            'modal_merge_registered': '/modal/settings/account/merge/registered/',
            'modal_merge_secondary': '/modal/settings/account/merge/secondary/',
            'ajax_merge_registered': '/ajax/settings/account/merge/registered/',
            'modal_contacts_edit': '/modal/profile/contacts/edit',
            'modal_contacts_new': '/modal/profile/contacts/new',
            'modal_contacts_groups_edit': '/modal/profile/contacts/groups/edit',
            'modal_contacts_groups_new': '/modal/profile/contacts/groups/new',
            'modal_contacts_add__select_group': '/modal/profile/contacts/groups/select',
            'modal_contacts_add__list': '/modal/profile/contacts/groups/list',
            'modal_recurring_event': '/modal/event/recurring_event/',
            'ajax_event_schedule': (data) => { return `/ajax/event/recurring_event/${data.event_id}/`; },
            'ajax_cancel_one_recurring': (data) => { return `/ajax/event/cancel_one_recurring/${data.event_id}/`; },
            'ajax_cancel_all_recurring': (data) => { return `/ajax/event/cancel_all_recurring/${data.event_id}/`; },
            'modal_edit_one_recurring': (data) => { return `/modal/event/edit_one_recurring/${data.event_id}/${data.old_date}/`; },
            'ajax_edit_one_recurring': (data) => { return `/ajax/event/edit_one_recurring/${data.event_id}/`; },
            'profile_events': '/profile/events/',
            'more_past_events': '/profile/events/past/more/',
            'ajax_remove_inbox_event': '/ajax/profile/events/remove/',
            'ajax_send_verify_email': '/profile/send_verify_email/',
            'modal_notification_prefs': '/modal/profile/notification/',
            'ajax_profile_contacts': '/ajax/profile/contacts/',
            'ajax_profile_multiple_contacts': '/ajax/profile/contacts/multiple/',
            'ajax_delete_multiple_contacts': '/ajax/profile/contacts/multiple/delete/',
            'ajax_profile_contacts_groups': '/ajax/profile/groups/',
            'ajax_contacts_groups__add_contacts': (data) => { return `/ajax/profile/groups/${data.group_id}/add_contacts/`; },
            'ajax_contacts_groups__remove_contact': (data) => { return `/ajax/profile/groups/${data.group_id}/remove/${data.contact_id}/`; },
            'ajax_remove_photo': '/ajax/profile/remove_photo/',
            'register': '/register/',
            'register_modal': '/modal/register/',
            'forgot_modal': '/modal/forgot/',
            'forgot_mobile': '/mobile/forgot/',
            'cstool_set_spam': (data) => { return `/cstool/set_spam/${data.event_id}/${data.status}/${data.task_name}/`; },
            'cstool_edit_admin_user': '/cstool/admin/users/edit/',
            'cstool_edit_admin_device_versions': '/cstool/admin/device-versions/edit/',
            'cstool_edit_phone_optout': '/cstool/admin/phone_optout/edit/',
            'cstool_experiments_set_variation': '/cstool/admin/experiments/set-variation-winner/',
            'cstool_spam_mark_as_seen': '/cstool/spam/event/mark_as_seen/',
            'cstool_spam_events': '/cstool/spam/events/',
            'cstool_event_actions': '/cstool/events/ajax_actions/',
            'cstool_user_actions': '/cstool/users/ajax_actions/',
            'cstool_event': '/cstool/events/event/',
            'view': (data) => { return `/event/${data.event_id}/`; },
            'send_message_modal': (data) => { return `/event/${data.event_id}/view/send_message_modal/`; },
            'send_sms_modal': (data) => { return `/event/${data.event_id}/view/send_sms_modal/`; },
            'ajax_view_profiles': (data) => { return `/ajax/event/${data.event_id}/view/profiles/`; },
            'ajax_view_rsvp': (data) => { return `/ajax/event/${data.event_id}/view/rsvp/`; },
            'modal_knot_link_registry': '/modal/event/link_registry/',
            'modal_knot_find_registry': '/modal/event/find_registry/',
            'ajax_logout': '/ajax_logout',
            'ajax_knot_search': '/ajax/knot_search/',
            'ajax_request_upload_path': '/ajax/upload/prepare',
            'ajax_fetchuyo': '/ajax/images/fetchuyo',
            'ajax_crop_image': (data) => { return `/ajax/images/${data.image_id}/crop`; },
            'ajax_content_feed': (data) => { return `/ajax/content/feed/${data.event_type}`; },
            'main_image': (data) => { return `/services/images/${data.image_id}/main`; },
            'large_image': (data) => { return `/services/images/${data.image_id}/large`; },
            'image_url': (data) => { return `/services/image_url/${data.image_id}/${data.size}`; },
            'ajax_comments': (data) => { return `/ajax/event/comments/${data.event_id}/${window.guest_id}/`; },
            'modal_add_to_calendar': (data) => { return `/modal/event/${data.event_id}/add_to_calendar/`; },
            'invite_more': this._invite_more,
            'send': '/event/send/',
            'cancel': '/event/cancel/',
            'whatsnext': (data) => { return `/whatsnext/${data.event_id}/`; },
            'edit': (data) => { return `/event/${data.event_id}/edit/`; },
            'upload_guest_csv': (data) => { return `/event/${data.event_id}/guests/csv/`; },
            'ajax_guestlist': (data) => { return `/ajax/event/${data.event_id}/dashboard/guestlist/`; },
            'event_dashboard': (data) => { return `/event/${data.event_id}/dashboard/`; },
            'parse_guest': '/ajax/event/parse_guests/',
            'guest_list_save': (data) => { return `/ajax/event/${data.event_id}/replace_guests/`; },
            'guest_list_add': (data) => { return `/ajax/event/${data.event_id}/add_guests/`; },
            'frp_updated': (data) => { return `/event/${data.event_id}/frp/updated/`; },
            'frp_message_sent': (data) => { return `/event/${data.event_id}/frp/message_sent/`; },
            'frp_sent': (data) => { return `/event/${data.event_id}/frp/sent/`; },
            'frp_saved': (data) => { return `/event/${data.event_id}/frp/saved/`; },
            'frp_canceled': (data) => { return `/event/${data.event_id}/frp/canceled/`; },
            'ajax_preview': '/event/preview/',
            'ajax_authenticated': '/ajax/authenticated/',
            'facebook_connect': '/services/extdata/oa2/login/facebook/login/',
            'google_plus_connect': '/services/extdata/oa2/login/google_plus/login/',
            'set_draft_guests': '/ajax/set_draft_guests/',
            'csv_import_contacts': '/profile/contacts/import/csv/',
            'ajax_subscribe': '/ajax/subscribe/',
            'ajax_send_sms': (data) => { return `/ajax/event/${data.event_id}/send_sms/`; },
            'event_map': (data) => `/event/${data.event_id}/map?gid=${data.guest_id }`,
            'event_map_redirect': (data) => `/event/${data.event_id}/map_redirect?gid=${data.guest_id }`,
            'print_event': (data) => `/event/${data.event_id}/export/print`,
            'print_event_premium': (data) => `/plus/view/${data.event_id}/${data.guest_id}/print_invitation/?`,
            'jifiti_url_redirect': (data) => `/event/${data.event_id}/jifiti_url/?guest_id=${data.guest_id }`,
            'ajax_notify_items': '/ajax/notify/items',
            'ajax_notify_update': '/ajax/notify/update',
            'all_notifications': '/all-notifications',
        };
    };

    get (name, params) {
        let url = this.urls[name];
        if (!url) {
            throw Error(`URL ${name} is not mapped`);
        }
        if (typeof url === 'function') {
            let escaped = {};
            if (params) {
                for (let k of Object.keys(params)) {
                    let v = params[k];
                    escaped[k] = encodeURIComponent(v);
                }
            }
            url = url(escaped);
        }

        return url;
    };

    _invite_more (params) {
        let event_id = params.eid || params.event_id || window.event_id;
        let p = {
            guest_id: params.gid || window.guest_id
        };
        let param_str = $.param(p);
        return `/event/${event_id}/invite_more/?${param_str}`;
    };

    _create (params) {
        let p = {
            template: params.template,
            event_type: params.event_type || params.eventType
        };
        let param_str = $.param(p);
        return `/event/create/?${param_str}`;
    };

    _profile (params) {
        if (params && params.uid) {
            return `/profile/public/${params.uid}/`;
        }
        return "/profile/";
    };

    _profile_private (params) {
        if (params.section) {
            if (params.section === 'events') {
                if (params.tab === 'upcoming') {
                    return this.get('profile_events');
                }
                if (params.tab === 'past') {
                    return this.get('profile_past_events');
                }
            }
            if (params.section === 'contacts') {
                return this.get('profile_contacts');
            }
        }

        return this.get('profile_edit');
    };

    _account_validate (params) {
        var k, p, url, v;
        url = this.get('verify_email');
        p = [];
        for (k in params) {
            v = params[k];
            p.push(k + "=" + v);
        }
        return url + '?' + p.join('&');
    };

    _reset_password (params) {
        return this.get('reset_password') + ("?token=" + params.chk);
    };

    _gallery (params) {
        if (params) {
            for (let k of Object.keys(params)) {
                let v = params[k];
                params[k] = unescape(v);
            }
        }
        let param_str = $.param(params);
        return `/gallery/?${param_str}`;
    };

};


export class LegacyURL {

    constructor (name1, params) {
        this.name =name1;
        this.params = params || {};
        return this;
    };

    add_param (key, value) {
        this.params[key] = value;
    };

};


export class LegacyRouter {

    parse (hash) {
        if (hash.match(/^#/)) {
            hash = hash.substring(1);
        }

        // parse the old hash location and return a LegacyURL instance
        let parts = hash.split(':');
        if (parts.length < 1) {
            return;
        }

        let url = new LegacyURL(parts[0]);

        if (parts.length > 1) {
            url = this.add_params(url, parts[1]);
        }
        return url;
    };

    add_params (url, param_str) {
        let pairs = param_str.split('&');
        for (let pair of pairs) {
            let key_value = pair.split('=');
            if (key_value.length > 1) {
                url.add_param(key_value[0], key_value[1]);
            }
        }
        return url;
    };

    to_typhoon (url) {
        return urls.get(url.name, url.params);
    };

    static check_hash () {
        let hash = window.location.hash;
        if (hash) {
            let router = new LegacyRouter();
            let url = router.parse(hash);
            let href = window.location.href;
            let left = href.indexOf('?');
            if (left !== -1) {
                let right = href.indexOf('#');
                if (right !== -1) {
                    router.add_params(url, href.slice(left + 1, right));
                }
            }

            let new_path;
            try {
                new_path = router.to_typhoon(url);
            } catch (error) {
                if ((window.console != null) && (console.log != null)) {
                    // console.log(`hash change not translated to typhoon: ${e}`);
                }
            }
            if (new_path) {
                if (window.LoadingModal != null) {
                    let loading_modal = new LoadingModal();
                    loading_modal.show('Loading...');
                }
                try {
                    tags.track_event('legacy-url');
                }
                catch(e) {}
                window.location.replace(new_path);
                return true;
            }
            return false;
        }
    };

};


var root;
if (typeof window !== "undefined" && window !== null) {
    root = window;
} else {
    root = eval('global');
}

root.urls = new URLs;
root.LegacyURL = LegacyURL;
root.LegacyRouter = LegacyRouter;

export default root.urls;

evite.resolvePromiseByName('common/urls', root.urls);



// WEBPACK FOOTER //
// ./assets/es6/common/urls.es6